import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';
import { useUIContext } from 'state/ui';
import { parseStringifiedJSON } from 'utils/parse-string';

type ItemHighlighted = {
  name: string;
  image: IImageFragment;
};

interface UseOrderDetailsReturn {
  totalPrice: string;
  itemHighlighted: ItemHighlighted | null;
  totalItems: number;
  itemNames: string;
}

export const useOrderDetailsCard = ({
  serverOrder,
}: {
  serverOrder: IServerOrder | IHistoricalOrder;
}): UseOrderDetailsReturn => {
  const { formatCurrencyForLocale } = useUIContext();

  const {
    cart: { cartEntries, subTotalCents },
  } = serverOrder;

  const totalItems = cartEntries.reduce((total, cartEntry) => total + (cartEntry.quantity ?? 1), 0);
  const totalPrice = formatCurrencyForLocale(subTotalCents);
  const itemNames = cartEntries.map(item => item.name).join(' - ');
  const itemHighlighted = {
    name: cartEntries[0]?.name || '',
    image: parseStringifiedJSON({
      value: cartEntries[0]?.image || '',
    }) as IImageFragment,
  };

  return {
    totalItems,
    totalPrice,
    itemHighlighted,
    itemNames,
  };
};
